import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SortableColumnComponent } from './sortable-column.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [SortableColumnComponent],
  imports: [CommonModule, FrontendIconsModule],
  exports: [SortableColumnComponent],
})
export class SortableColumnModule {}
